<template>
  <div class="notes-container main-content">
    <custom-headers :title="headerTitle" />
    <div
      class="backpage-container"
      @mouseenter="triggerBackpageAnimate()"
      @mouseleave="offBackpageAnimate()"
      @click="backpage"
    >
      <lottie
        :options="backpageDefaultOptions"
        @animCreated="anim => backpageHandleAnimation(anim)"
      />
    </div>
    <a-row type="flex" class="note-list">
      <a-col
        :span="8"
        :lg="6"
        class="note-list-item"
        :class="item.class"
        v-for="item in noteList"
        :key="item.id"
      >
        <a :href="item.href" target="_blank">
          <a-col :span="24">
            <div
              v-for="(descriptionItem, descriptionIndex) in item.description"
              :key="descriptionIndex"
            >
              {{ descriptionItem }}
            </div>
          </a-col>
        </a>
      </a-col>
      <!-- <a-col :span="6" class="note-list-item">bbb</a-col>
      <a-col :span="6" class="note-list-item">ccc</a-col>
      <a-col :span="6" class="note-list-item">ddd</a-col>
      <a-col :span="6" class="note-list-item">aaa</a-col>
      <a-col :span="6" class="note-list-item">bbb</a-col>
      <a-col :span="6" class="note-list-item">ccc</a-col>
      <a-col :span="6" class="note-list-item">ddd</a-col>
      <a-col :span="6" class="note-list-item">aaa</a-col>
      <a-col :span="6" class="note-list-item">bbb</a-col>
      <a-col :span="6" class="note-list-item">ccc</a-col>
      <a-col :span="6" class="note-list-item">ddd</a-col> -->
    </a-row>
  </div>
</template>
<script>
import Lottie from "vue-lottie";
import * as backArrowJSON from "../assets/json/back-arrow.json";
import CustomHeaders from "../components/Header.vue";

export default {
  name: "Notes",
  components: {
    "custom-headers": CustomHeaders,
    lottie: Lottie
  },
  data() {
    return {
      headerTitle: "Notes",
      backpageDefaultOptions: { animationData: backArrowJSON.default },
      noteList: [
        {
          id: "noteList-1",
          description: ["Component 文件範例"],
          href: "https://hackmd.io/@evantsai/HyBhEQTp_",
          class: ""
        },
        {
          id: "noteList-2",
          description: ["React Router SSR ", "with Create react app"],
          href: "https://hackmd.io/@evantsai/H1kOGR4ju",
          class: ""
        },
        {
          id: "noteList-3",
          description: ["Web Worker"],
          href: "https://hackmd.io/@evantsai/rymE9Jtvs",
          class: ""
        },
        {
          id: "noteList-4",
          description: ["Create React APP 相關"],
          href: "https://hackmd.io/@evantsai/B1_SSV6Ks",
          class: ""
        },
        {
          id: "noteList-5",
          description: ["Qwik 框架介紹"],
          href: "https://hackmd.io/@evantsai/S1KfWRU4j"
        },
        {
          id: "noteList-6",
          description: ["Git 相關"],
          href: "https://hackmd.io/@evantsai/H1gsBcBuc",
          class: ""
        },
        {
          id: "noteList-7",
          description: ["Cross Site Scripting", "(XSS)攻擊"],
          href: "https://hackmd.io/@evantsai/Hk-xjJVmj",
          class: ""
        },
        {
          id: "noteList-8",
          description: ["npm 推薦工具"],
          href: "https://hackmd.io/@evantsai/S1dz9qF9c",
          class: ""
        },
        {
          id: "noteList-9",
          description: ["Webpack 設定", "dev prod 開發環境"],
          href: "https://hackmd.io/@evantsai/rJKpcqTts",
          class: ""
        },
        {
          id: "noteList-10",
          description: ["防Clickjackng攻擊"],
          href: "https://hackmd.io/@evantsai/BywSlYRFh",
          class: ""
        }
      ]
    };
  },
  methods: {
    backpageHandleAnimation(anim) {
      this.backpageAnim = anim;
      this.backpageAnim.stop();
    },
    triggerBackpageAnimate() {
      this.backpageAnim.play();
    },
    offBackpageAnimate() {
      this.backpageAnim.stop();
    },
    backpage() {
      this.$router.push("/");
    },
    setScaleTransition(list, duration) {
      const delayAction = index => {
        setTimeout(() => {
          if (list[index]) {
            list[index].class = "scale-transition";
          }
          if (index < list.length - 1) {
            delayAction(index + 1);
          }
        }, duration);
      };
      delayAction(0);
    }
  },
  mounted() {
    this.setScaleTransition(this.noteList, 150);
  }
};
</script>
<style lang="scss" scoped>
@import "../css/variable.scss";

.main-content {
  .note-list {
    width: 100%;
    font-family: "Microsoft JhengHei";
    font-weight: bold;
    font-size: 1rem;

    .note-list-item {
      background-color: #fff;
      border-right: 1px solid #d9d9d9;
      border-top: 1px solid #d9d9d9;
      transition: all 0.3s;
      line-height: 1.5rem;
      transform: scale(0);
      padding: 20px;

      &:hover {
        box-shadow: 0px 5px 5px 1px #c9c9c9;
        transform: translate(0px, -5px) !important;
        transition: all 0.3s;
        z-index: 1;
        position: relative;
        cursor: pointer;
      }
      &:nth-of-type(4n + 1) {
        border-left: 1px solid #d9d9d9;
      }
      &:nth-last-of-type(-n + 4) {
        border-bottom: 1px solid #d9d9d9;
      }
      &.scale-transition {
        animation: scaleTransition 1s forwards;
      }
      > a {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 200px;
        flex-wrap: wrap;
        text-align: center;
      }
    }
  }
}

@keyframes scaleTransition {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}

@media screen and(max-width:991px) {
  .main-content {
    .note-list {
      .note-list-item {
        &:nth-of-type(4n + 1) {
          border-left: 0;
        }
        &:nth-last-of-type(-n + 4) {
          border-bottom: 0;
        }
        &:nth-of-type(3n + 1) {
          border-left: 1px solid #d9d9d9;
        }
        &:nth-last-of-type(-n + 3) {
          border-bottom: 1px solid #d9d9d9;
        }
      }
    }
  }
}
</style>
